import { firstDayInMonth } from '@shared/utils/date.utils';
import { lastDayInMonth } from '@shared/utils/date.utils';

class AcrewardsModel {
  constructor() {
    this.balanceSummary = null;
    this.balancePerProduct = null;
    this.transactionTable = {
      transactions: null,
      pagination: null
    };
    this.customerProducts = null;
    this.availableBalance = null;
    this.currency = null;
    this.turnOverCommission = null;
    this.periods = null;
    this.filterRevenueShare = 0;
    this.allowRevenueShare = null;
    this.totalRunningCommission = null;
    this.totalWithdrawableAmount = null;
    this.turnoverWinLossCommission = null;
    this.runningCommissions = null;
    this.products = null;
    this.members = null;
    this.totals = null;
    this.dateFrom = null;
    this.dateTo = null;
    this.orderBy = 'productName';
    this.pageParams = {
      recordsTotal: null,
      recordsFiltered: null,
      limit: null,
      page: null,
      offset: null,
      orderBy: null,
      precision: null,
      filterRevenueShare: null,
      hideZeroCommission: null,
      sort: null
    }
  }

  toPayload() {
    return {
      dwlDateFrom: this.dateFrom,
      dwlDateTo: this.dateTo,
      limit: this.pageParams.limit,
      page: this.pageParams.page,
      offset: this.pageParams.offset,
      orderBy: this.pageParams.orderBy,
      precision: this.pageParams.precision,
      filterRevenueShare: this.filterRevenueShare,
      hideZeroCommission: this.pageParams.hideZeroCommission,
      sort: this.pageParams.sort
    };
  }
}

export default AcrewardsModel;



// WEBPACK FOOTER //
// ./client/app/pages/acrewards/model/acrewards.model.js